<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import {
        loadOptions,
        optionToValue,
        valueToOption,
    } from '$components/Form/SelectJobTitle/utils';
    import { getContainer } from '$components/Context/ContainerContext';
    import MobileComboboxRow from '$components/Form/ModalMobile/MobileComboboxRow.svelte';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, number | null>;
    export let label: string;
    export let required: boolean = false;
    export let id: string | null = null;
    export let prefixId: string | undefined = undefined;
    export let modalTitle: string | null = null;

    const { apollo } = getContainer();
</script>

<MobileComboboxRow
    {form}
    {field}
    {label}
    {required}
    {prefixId}
    {id}
    {modalTitle}
    loadOptions={(q) => loadOptions(apollo, q)}
    {optionToValue}
    valueToOption={(v) => valueToOption(apollo, v)}
>
    <svelte:fragment slot="description" let:option let:class={className}>
        {#if option != null}
            <span class={className}>{option.name}</span>
        {/if}
    </svelte:fragment>

    <div slot="option" let:option class="flex gap-[8px] pr-[8px] pl-[16px] mb-[8px]">
        <div class="line-clamp-2 font-normal text-13/[18px] tracking-[-1%] text-black">
            {option.name}
        </div>
    </div>
</MobileComboboxRow>
